// import React from "react";
// import Form from "react-bootstrap/Form";

// const TextField = ({
//   type,
//   value,
//   name,
//   onChange,
//   submitted = false,
//   disabled,
//   required,
//   invalidInputMessage,
//   ...rest
// }) => {
//   const isSubmitted = submitted && !value;

//   return (
//     <>
//       <Form.Control
//         style={{ border: isSubmitted ? "1px solid red" : "", fontSize: "13px" }}
//         type={type}
//         value={value}
//         name={name}
//         onChange={(e) => onChange(e)}
//         className="form__control"
//         disabled={disabled}
//         required={required ?? false}
//         {...rest}
//       />
//       {/*
//         <Form.Control.Feedback>
//         {validInputMessage}
//         <Form.Control.Feedback>
//         */}
//       <Form.Control.Feedback type="invalid">
//         {invalidInputMessage}
//       </Form.Control.Feedback>
//     </>
//   );
// };
// export default TextField;

import React from "react";
import Form from "react-bootstrap/Form";

/** Convert YYYY-MM-DD → DD/MM/YYYY for display */
const toDMY = (val) => {
  if (!val) return "";
  const s = String(val).trim();
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(s)) return s;
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  return s;
};

/** Convert DD/MM/YYYY → YYYY-MM-DD (for APIs / state) */
const toISO = (val) => {
  if (!val) return "";
  const s = String(val).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (m) {
    const d = m[1].padStart(2, "0");
    const mo = m[2].padStart(2, "0");
    return `${m[3]}-${mo}-${d}`;
  }
  return s;
};

const TextField = ({
  type,
  value,
  name,
  onChange,
  submitted = false,
  disabled,
  required,
  invalidInputMessage,
  /** Parent keeps ISO (YYYY-MM-DD). Set false to keep DD/MM/YYYY in state */
  dateAsISO = true,
  ...rest
}) => {
  const isDate = type === "date";
  const isSubmitted = submitted && !value;

  const displayValue = isDate ? toDMY(value) : value ?? "";

  const handleChange = (e) => {
    if (!isDate) {
      onChange(e);
      return;
    }

    const raw = e.target.value;
    let next = raw;
    // When user finishes typing DD/MM/YYYY, convert to ISO for parent state
    if (dateAsISO && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(raw.trim())) {
      next = toISO(raw);
    }

    const synthetic = {
      ...e,
      target: {
        ...e.target,
        name: name || e.target.name,
        value: next,
      },
    };
    onChange(synthetic);
  };

  return (
    <>
      <Form.Control
        style={{
          border: isSubmitted ? "1px solid red" : "",
          fontSize: "13px",
        }}
        type={isDate ? "text" : type}
        value={displayValue}
        name={name}
        onChange={handleChange}
        className="form__control"
        disabled={disabled}
        required={required ?? false}
        placeholder={isDate ? "DD/MM/YYYY" : rest.placeholder}
        maxLength={isDate ? 10 : rest.maxLength}
        inputMode={isDate ? "numeric" : rest.inputMode}
        {...rest}
      />
      <Form.Control.Feedback type="invalid">
        {invalidInputMessage}
      </Form.Control.Feedback>
    </>
  );
};

export default TextField;